import {useEffect,useState} from 'react';
import type {BallColorGroup} from '@platform/contracts/x';
import {Ball} from '@platform/ui/Ball';
import './RoomBackdrop.css';

// Decorative, stable samples from the existing ball palette, independent of
// draw results. The live balls and board remain the only readable game state.
export function RoomBackdrop({groups}:{groups:BallColorGroup[]}){
 const [paused,setPaused]=useState(()=>document.hidden);
 useEffect(()=>{
  const update=()=>setPaused(document.hidden);
  document.addEventListener('visibilitychange',update);
  return()=>document.removeEventListener('visibilitychange',update);
 },[]);
 return <div className="room-backdrop" aria-hidden="true" inert data-paused={paused}>
  {groups.filter(group=>group.numbers.length).slice(0,6).map((group,index)=><div className="room-backdrop-ball" key={group.id}>
   <Ball groups={groups} number={group.numbers[Math.min(index+2,group.numbers.length-1)]}/>
  </div>)}
 </div>;
}
